var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('user-password-change',{attrs:{"component-title":'Zmień moje hasło'}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }